import { HttpParams } from '@angular/common/http';

export function parseParamsFromObject(paramsObject: { [key: string]: any }): HttpParams {
  let params = new HttpParams();

  Object.entries(paramsObject).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => params = params.append(key, v));
    } else if (value) {
      params = params.set(key, value);
    }
  });

  return params;
}